import RequestAbstract from "../abstract";

export default class PublicCurrencies extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-currencies";
    }

}
